"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeData = void 0;
var utils_1 = require("../utils");
var getThemeData = function (themeItem, mixin, withKebabCase) {
    var _a;
    if (mixin === void 0) { mixin = {}; }
    var _b = themeItem.color, color = _b === void 0 ? {} : _b, _c = themeItem.shadow, shadow = _c === void 0 ? {} : _c, _d = themeItem.borderRadius, borderRadius = _d === void 0 ? {} : _d, _e = themeItem.spacing, spacing = _e === void 0 ? {} : _e;
    var themeData = (0, utils_1.extractTokenData)(color);
    var themeShadow = (0, utils_1.extractTokenData)(shadow);
    var themeBorderRadius = (0, utils_1.extractTokenData)(borderRadius);
    var themeSpacing = (0, utils_1.extractTokenData)(spacing);
    var withPrefixDesign = false;
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (0, utils_1.objectToCSSVariables)(themeData, '', withPrefixDesign, withKebabCase)), (0, utils_1.objectToCSSShadowVariables)(themeShadow, withKebabCase)), (0, utils_1.objectToCSSVariables)(themeBorderRadius, '', withPrefixDesign, withKebabCase)), (0, utils_1.objectToCSSVariables)(themeSpacing, '', withPrefixDesign, withKebabCase)), (0, utils_1.objectToCSSVariables)(mixin, '', withPrefixDesign, withKebabCase)), (_a = { color: 'var(--text-primary)' }, _a['background-color'] = 'var(--background-primary)', _a));
};
exports.getThemeData = getThemeData;
//# sourceMappingURL=getThemeData.js.map